import React from "react";
import { Row, Col } from "reactstrap";
import check from "../../assets/images/check_blue_mayca.svg";
import './index.css'

const RedirectAppPage = () => {

    const handleOpenApp = () => {
        window.location.href = "com.maycaone.app:/callback";
      };
  return (
    <div>
      <Row>
        <Col sm={12} xs={12} md={12}>
          <div className="d-flex w-100 justify-content-center mt-5">
            <img src={check} alt="Registro Exitoso" />{" "}
          </div>
          <div className="w-100 mt-5 text-center">
            <span className="fw-bold fs-2">¡Felicidades!</span>
            <p className="mt-2 fs-3 mx-3">
              Has creado tu cuenta en Mayca One. Ahora dirigite al app y utilizá
              tus nuevas credenciales para Iniciar Sesión.
            </p>
          </div>
          <div className="w-100 d-flex justify-content-center mt-3">
              <button
                className="redirect-app-btn"
                size="lg"
                onClick={handleOpenApp}
              >
                Ir a Mayca One
              </button>
            </div>
        </Col>
      </Row>
    </div>
  );
};

export default RedirectAppPage;
